"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Modal = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("react-date-range/dist/styles.css");

require("react-date-range/dist/theme/default.css");

var _dateFns = require("date-fns");

var _reactDateRange = require("react-date-range");

var _reactPortal = require("react-portal");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Modal = _styledComponents["default"].div.withConfig({
  displayName: "date__Modal",
  componentId: "sc-8l9wbi-0"
})(["height:100vh;width:100vw;position:absolute;top:0;left:0;display:flex;align-items:center;align-content:center;z-index:9999999999;> div{display:flex;flex-direction:column;border-radius:3px;padding:20px;z-index:9999999999;background:#fff;margin:0 auto;}"]);

exports.Modal = Modal;
Modal.Bg = _styledComponents["default"].div.withConfig({
  displayName: "date__Bg",
  componentId: "sc-8l9wbi-1"
})(["z-index:9999999999;background:rgb(0,0,0,0.5);position:absolute;top:0;left:0;bottom:0;right:0;width:100vw;height:100vh;"]);

var OutsideAlerter = _react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$onOutsideClick = _ref.onOutsideClick,
      onOutsideClick = _ref$onOutsideClick === void 0 ? function () {} : _ref$onOutsideClick;
  var wrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onOutsideClick();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: wrapperRef
  }, children);
});

var DateComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DateComponent, _React$Component);

  var _super = _createSuper(DateComponent);

  function DateComponent() {
    var _this;

    (0, _classCallCheck2["default"])(this, DateComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (date, closePortal) {
      var formattedDate = _this.props.formatSubmit(date);

      _this.props.onChange(formattedDate);

      closePortal();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getValue", function () {
      var value = _this.props.value;
      if ((0, _dateFns.isDate)(value) && (0, _dateFns.isValid)(value)) return value;

      var parsedValue = _this.props.parseValue(value);

      return (0, _dateFns.isDate)(parsedValue) && (0, _dateFns.isValid)(parsedValue) ? parsedValue : undefined;
    });
    return _this;
  }

  (0, _createClass2["default"])(DateComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          label = _this$props.label,
          options = _this$props.options,
          disabled = _this$props.disabled;
      var value = this.getValue();
      return /*#__PURE__*/_react["default"].createElement(_reactPortal.PortalWithState, {
        closeOnOutsideClick: true,
        closeOnEsc: true
      }, function (_ref2) {
        var openPortal = _ref2.openPortal,
            closePortal = _ref2.closePortal,
            isOpen = _ref2.isOpen,
            portal = _ref2.portal;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label && /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: name
        }, label), /*#__PURE__*/_react["default"].createElement("input", {
          type: "text",
          className: "datePicker",
          value: value ? _this2.props.formatDisplay(value) : '',
          placeholder: _this2.props.placeholder,
          onClick: openPortal,
          style: {
            cursor: disabled ? 'default' : 'pointer'
          },
          readOnly: true,
          disabled: disabled
        }), portal( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Modal.Bg, null), /*#__PURE__*/_react["default"].createElement(Modal, null, /*#__PURE__*/_react["default"].createElement(OutsideAlerter, {
          onOutsideClick: closePortal
        }, label && /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: name
        }, label), /*#__PURE__*/_react["default"].createElement(_reactDateRange.Calendar, (0, _extends2["default"])({
          date: value,
          onChange: function onChange(data) {
            return _this2.onChange(data, closePortal);
          }
        }, options)), /*#__PURE__*/_react["default"].createElement("button", {
          onClick: closePortal
        }, "Cancel"))))));
      });
    }
  }]);
  return DateComponent;
}(_react["default"].Component);

DateComponent.defaultProps = {
  label: undefined,
  value: new Date(),
  options: {},
  placeholder: "Click to select a date",
  parseValue: function parseValue(value) {
    return (0, _dateFns.parseISO)(value);
  },
  formatSubmit: function formatSubmit(date) {
    return (0, _dateFns.format)(date, 'yyyy-MM-dd');
  },
  formatDisplay: function formatDisplay(date) {
    return (0, _dateFns.format)(date, 'yyyy-MM-dd');
  }
};
DateComponent.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].object,
  parseValue: _propTypes["default"].func,
  formatDisplay: _propTypes["default"].func,
  formatSubmit: _propTypes["default"].func
};
var _default = DateComponent;
exports["default"] = _default;